import { stringify } from "query-string";
import { MIN_PAGE_COUNT, MAX_PAGE_COUNT } from "scripts/constants";
import { apiFetchEditionCost, apiFetchCost } from "scripts/constants/api";
import { throwError } from "./throwError";

const fetchOrderCost = params => {
  if (+params.itemCount > 0 && +params.itemCount < 999999 && +params.pagesCount >= MIN_PAGE_COUNT && +params.pagesCount <= MAX_PAGE_COUNT) {
    const query = {
      page_count: params.pagesCount,
      items_count: params.itemCount,
      postcode: params.postalCode,
      city: params.city
    };
    const url = `${apiFetchCost}?${stringify(query)}`;
    return fetch(url).then(response => response.json()).catch(error => throwError({
      error
    }));
  }

  return Promise.resolve({
    result: {
      print_cost: 0,
      delivery_cost: 0
    }
  });
};

const fetchPrintedCost = params => {
  if (+params.itemCount < 999999 && +params.pagesCount >= MIN_PAGE_COUNT && +params.pagesCount <= MAX_PAGE_COUNT) {
    const query = {
      page_count: params.pagesCount,
      items_count: params.itemCount
    };
    const url = `${apiFetchEditionCost}?${stringify(query)}`;
    return fetch(url).then(response => response.json()).then(data => data.result).catch(error => throwError({
      error
    }));
  }

  return Promise.resolve({
    print_cost: 0
  });
};

export { fetchOrderCost, fetchPrintedCost };